export default "__VITE_ASSET__OcJr4tlE__"